(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("rLoginLedgerProvider", [], factory);
	else if(typeof exports === 'object')
		exports["rLoginLedgerProvider"] = factory();
	else
		root["rLoginLedgerProvider"] = factory();
})(this, function() {
return 